// Vercel、Local上の環境変数 NEXT_PUBLIC_ENVIROMENT で出し分けをする.
// 使用例 gmoTokenUrl[`${process.env.NEXT_PUBLIC_ENVIROMENT}`]

export const gmoTokenUrl = {
  Test: "https://stg.static.mul-pay.jp/ext/js/token.js",
  Production: "https://static.mul-pay.jp/ext/js/token.js"
}

// process.env.NODE_ENVだと、Vercelのtest環境がproductionと認識されてしまうため.
export const vercelEnv = {
  Test: "test",
  Production: "production"
}
